/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { VcdsPeerDeployment } from './vcdsPeerDeployment';
import { VcdsComponentIdAndType } from './vcdsComponentIdAndType';


export interface DetailedVcdsDeploymentInventoryTree { 
    peer_deployment?: Array<VcdsPeerDeployment>;
    components?: Array<VcdsComponentIdAndType>;
}

